import "dayjs/locale/uk";

import { DataType, DocumentsFormProps } from "../types";
import { useContext, useEffect, useState } from "react";

import Checkbox from "antd/lib/checkbox";
import DatePicker from "antd/lib/date-picker";
import Directories from "../../../directories";
import Drawer from "../../../ui/drawer";
import { DrawerProvider } from "../../../../contexts/drawer/index.context";
import Form from "antd/lib/form";
import { FormContext } from "../../../../contexts/form/index.context";
import Input from "antd/lib/input";
import { MergedColumnType } from "../../../ui/table/utils/types";
import { ModalContext } from "../../../../contexts/modal/index.context";
import Select from "antd/lib/select";
import { SessionContext } from "../../../../contexts/session/index.context";
import Space from "antd/lib/space";
import { TableContext } from "../../../../contexts/table/index.context";
import Tabs from "antd/lib/tabs";
import type { TabsProps } from "antd/es/tabs";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import User from "../../../../services/user";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { request } from "../../../../services";
import { setFieldValuesFunctions } from "../utils/set-field-values";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import { MergeCellsOutlined } from "@ant-design/icons";

import en from "antd/es/date-picker/locale/en_US";
import ua from "antd/es/date-picker/locale/uk_UA";

//Utils

//Components

//UI

//Locale

dayjs.extend(customParseFormat);
dayjs.locale("uk");

const { TextArea } = Input;

export default function DocumentsForm(props: DocumentsFormProps) {
  const location = useLocation();
  const currentUser = User.decode();
  const [loading, setLoading] = useState(false);
  const { intl, language } = useContext(TranslationContext);

  const { form } = useContext(FormContext);
  const { rowData, contextTableData, setContextTableData } = useContext(TableContext);
  const { sessionData, setSessionData, tableState, setTableState } = useContext(SessionContext);
  const { activeModal, disabled, setDisabled, setRefresh } =
    useContext(ModalContext);
  const edit = activeModal === "edit";
  const isIncoming = location.pathname === "/documents/incoming";
  const isOutcoming =
    location.pathname === "/documents/outcoming" ||
    sessionData.eta_const_typedoc_id === 2;
  const isInternal =
    location.pathname === "/documents/internal" ||
    sessionData.eta_const_typedoc_id === 3;
  const dateFormatList = ["DD.MM.YYYY", "DD-MM-YYYY"];
  const [selectData, setSelectData] = useState<DataType[]>([]);
  const [correspondentData, setCorrespondentData] = useState<
    MergedColumnType[]
  >([]);
  const paths: { [key: string]: number } = {
    "/documents/incoming": 1,
    "/documents/outcoming": 2,
    "/documents/internal": 3,
  };
// console.log("contextTableDataDavid", contextTableData);
  const { kontragentId_, kontragent_name } = sessionData;
  const ids = kontragentId_?.split(", ").map(Number);
  const names = kontragent_name?.split(", ");

  const correspondentValues = ids?.map((id:Number, index:any) => ({
    value: id || 0,
    label: names?.[index],
  }));

  const [placeOfRegistrationId, setPlaceOfRegistrationId] = useState<number | undefined>(edit ? sessionData.PlaseRegistrationId : undefined);
  const [typeOfDocumentId, setTypeOfDocumentId] = useState<number | undefined>(edit ? sessionData.typeDocId : undefined);
  const [documentIndexId, setDocumentIndexId] = useState<number | undefined>(edit ? sessionData.referenceId : undefined);
  const [correspondentId, setCorrespondentId] = useState<number | undefined>(edit ? sessionData.kontragentId: undefined);

  const [correspondentIdOut, setCorrespondentIdOut] = useState<undefined | { value: number; label: any }[]>(edit ? correspondentValues: undefined);
  const [correspondentsIds, setCorrespondentsIds] = useState<number[]>();


  const [addressedId, setAddressedId] = useState<number | undefined>(edit ? sessionData.RecipientId : undefined);
  const [typeOfDeliveryId, setTypeOfDeliveryId] = useState<number | undefined>(edit ? sessionData.typeSendId : undefined);
  const [caseId, setCaseId] = useState<number | undefined>(edit ? sessionData.officialDocId : undefined);
  const [signatoryId, setSignatoryId] = useState<number | undefined>(edit ? sessionData.SignId : undefined);
  const [authorId, setAuthorId] = useState<number | undefined>(edit ? sessionData.AuthorId : undefined);

  const typeOfDocument = paths[location.pathname] || null;

  type CorrespondentObject = {
    key?: any,
    value: number | null,
    label: string | null,
  }

    type CorrespondentObjectF = {
    // key?: any,
    value: number,
    label: string,
  }

  const selectOptions = selectData?.map((item) => ({
    value: item.id,
    label: item.Name,
  }));

  // const correspondentOptions: Array<CorrespondentObject> = correspondentData?.map((item): CorrespondentObject => ({
  //   value: item.id,
  //   label: item.Name,
  // }));

  function formatedCorrespOut(corresp : CorrespondentObjectF[]): number[] | [] {
    const doneList = corresp.map((v, i)=>(
      v.value
    ));
    console.log("DONE LIST ", doneList);
    return doneList;
  }

  // const filterOption = (
  //   input: string,
  //   option?: CorrespondentObject
  // ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    setContextTableData([]);
    if (activeModal === "edit" && sessionData) {
      let path = location.pathname;
      if (sessionData.eta_const_typedoc_id) {
        switch (sessionData.eta_const_typedoc_id) {
          case 1:
            path = "/documents/incoming";
            break;
          case 2:
            path = "/documents/outcoming";
            break;
          case 3:
            path = "/documents/internal";
            break;
        }
      }

      const setFieldValues = setFieldValuesFunctions[path];
      setFieldValues && setFieldValues(form, sessionData);
    } else {
      form.resetFields();
    }
  }, [activeModal, sessionData]);

  const pathname = location.pathname.split("/").pop();
  const typeMap: { [key: string]: number } = {
    incoming: 1,
    outcoming: 2,
    internal: 3,
  };
  const typeId = typeMap[pathname || ""];

  const fetchSelectData = async () => {
    const content = (
      await request(
        `${location.pathname.split("/").slice(0, 2).join("/")}/getdataselect`,
        {
          method: "post",
          body: { id: typeId },
          cancelTokenKey: "getdataselect",
        }
      )
    )?.content;
    setSelectData(content || []);
  };

  const fetchCorrespondentData = async () => {
    const content = (
      await request(
        `${location.pathname
          .split("/")
          .slice(0, 2)
          .join("/")}/getcorrespondent`,
        {
          method: "get",
          cancelTokenKey: "getcorrespondent",
        }
      )
    )?.content;
    setCorrespondentData(content || []);
  };

  function setFormFields() {
    // console.log("ROWDATAdata 1", rowData);

    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};

      if (rowData["/directories/structural-units"]) {
        fieldsValue.placeOfRegistration =
          rowData["/directories/structural-units"].id;
          setPlaceOfRegistrationId(rowData["/directories/structural-units"].id);
      }
      if (rowData["/directories/types-of-documents"]) {
        fieldsValue.typeOfDocument =
          rowData["/directories/types-of-documents"].id;
          setTypeOfDocumentId(rowData["/directories/types-of-documents"].id);
      }
      if (rowData["/directories/indexes-of-documents"]) {
        fieldsValue.documentIndex =
          rowData["/directories/indexes-of-documents"].id;
          setDocumentIndexId(rowData["/directories/indexes-of-documents"].id);
      }
      if (rowData["/directories/correspondents"]) {
        fieldsValue.correspondent = rowData["/directories/correspondents"].id;
        setCorrespondentId(rowData["/directories/correspondents"].id);
      }
      if (rowData["/directories/outcoming-correspondents"]) {
        const correspondentsOut = contextTableData.map((value) => ({
          value: Number(value.id),
          label: String(value.Name),
        }));
        fieldsValue.correspondentsOut = correspondentsOut;
        console.log('Correspondets ==================== ', correspondentsOut);
        const arrNumb = formatedCorrespOut(correspondentsOut)
        console.log('Correspondets ==================== 2222222', arrNumb);

        setCorrespondentsIds(arrNumb);
        setCorrespondentIdOut(correspondentsOut);
      }
      if (rowData["/directories/employees"]) {
        fieldsValue.addressed = rowData["/directories/employees"].id;
        setAddressedId(rowData["/directories/employees"].id);
      }
      if (rowData["/directories/types-of-deliveries"]) {
        fieldsValue.typeOfDelivery =
          rowData["/directories/types-of-deliveries"].id;
          setTypeOfDeliveryId(rowData["/directories/types-of-deliveries"].id);
      }
      if (rowData["/directories/nomenclature-of-cases-current"]) {
        fieldsValue.case =
          rowData["/directories/nomenclature-of-cases-current"].id;
          setCaseId(rowData["/directories/nomenclature-of-cases-current"].id);
      }
      if (rowData["/directories/employees/signatory"]) {
        fieldsValue.signatory = rowData["/directories/employees/signatory"].id;
        setSignatoryId(rowData["/directories/employees/signatory"].id);
      }
      if (rowData["/directories/employees/author"]) {
        fieldsValue.author = rowData["/directories/employees/author"].id;
        setAuthorId(rowData["/directories/employees/author"].id);
      }
      if (rowData["/directories/nomenclature-of-cases"]) {
        fieldsValue.case = rowData["/directories/nomenclature-of-cases"].id;
        setCaseId(rowData["/directories/nomenclature-of-cases"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  useEffect(() => {
  if (isOutcoming) {
    fetchCorrespondentData(); // тепер опції є ще до відкриття дропдауну select для редагування outcoming
  }
}, [isOutcoming]);

  let items: TabsProps["items"] = [
    {
      key: "1",
      label: intl("document"),
      children: (
        <DrawerProvider>
          {/* <Form.Item
            // {...fullLayout}
            // label={intl("registration-department")}
            name="registrationDepartment"
            // rules={[
            //   {
            //     required: true,
            //     message: intl("registration-department-required"),
            //   },
            // ]}
          >
            <Drawer>null</Drawer>
          </Form.Item> */}
          <Form.Item
            label={intl("place-of-registration")}
            name="placeOfRegistration"
          >
            <Drawer
              url="/directories/structural-units"
              name={edit ? sessionData.PlaseRegistration : undefined}
              name2={rowData["/directories/structural-units"]?.data.Name}
              setFormFields={setFormFields}
              fieldName={"placeOfRegistration"}
            >
              <Directories url="/directories/structural-units" selectedRowId={placeOfRegistrationId}/>
            </Drawer>
          </Form.Item>
          <Form.Item label={intl("document-log")} name="documentLog">
            <Select
              labelInValue
              onChange={(value) => {
                form.setFieldsValue({ documentLog: value });
              }}
              onDropdownVisibleChange={fetchSelectData}
              options={selectOptions}
              allowClear
            />
          </Form.Item>
          <Form.Item label={intl("type-of-document")} name="typeOfDocument">
            <Drawer
              url="/directories/types-of-documents"
              name={edit ? sessionData.typeDocName : undefined}
              name2={rowData["/directories/types-of-documents"]?.data.Name}
              setFormFields={setFormFields}
              fieldName={"typeOfDocument"}
            >
              <Directories
                url="/directories/types-of-documents"
                type={typeOfDocument}
                selectedRowId={typeOfDocumentId}
              />
            </Drawer>
          </Form.Item>
          {!isInternal && (
            <Form.Item
              label={intl("indexes-of-documents")}
              name="documentIndex"
            >
              <Drawer
                url="/directories/indexes-of-documents"
                name={edit ? sessionData.referenceName : undefined}
                name2={rowData["/directories/indexes-of-documents"]?.data.Name}
                setFormFields={setFormFields}
                fieldName={"documentIndex"}
              >
                <Directories url="/directories/indexes-of-documents" selectedRowId={documentIndexId}/>
              </Drawer>
            </Form.Item>
          )}
          <Space className={styles["space"]}>
            <Form.Item
              label={intl("num-document")}
              name="numDocument"
              rules={[
                {
                  required: true,
                  message: intl("num-document-required"),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={intl("from")}
              name="fromRegisteredDocument"
              rules={[
                {
                  required: true,
                  message: intl("from-receipt"),
                },
              ]}
            >
              <DatePicker
                format={dateFormatList}
                placeholder={intl("choose-date-placeholder")}
                locale={language ? ua : en}
              />
            </Form.Item>
            {!isIncoming && (
              <Form.Item name="project" valuePropName="checked">
                <Checkbox>{intl("project")}</Checkbox>
              </Form.Item>
            )}
          </Space>
          {!(isOutcoming || isInternal) && (
            <Space className={styles["space"]}>
              <Form.Item label={intl("num-output")} name="numOutput">
                <Input />
              </Form.Item>
              <Form.Item label={intl("from")} name="fromRegisteredOutput">
                <DatePicker
                  format={dateFormatList}
                  placeholder={intl("choose-date-placeholder")}
                  locale={language ? ua : en}
                />
              </Form.Item>
            </Space>
          )}
          {!isInternal &&
            (!isOutcoming ? (
              <Form.Item label={intl("correspondent")} name="correspondent">
                <Drawer
                  url="/directories/correspondents"
                  name={edit ? sessionData.kontragentName : undefined}
                  name2={rowData["/directories/correspondents"]?.data.Name}
                  setFormFields={setFormFields}
                  fieldName={"correspondent"}
                >
                  <Directories url="/directories/correspondents" selectedRowId={correspondentId}/>
                </Drawer>
              </Form.Item>
            ) : (
              // <Form.Item label={intl("correspondent")} name="correspondent">
              //   <Select
              //     mode={/* edit ? undefined :  */ "multiple"}
              //     onChange={(_, value) => {
              //       form.setFieldsValue({
              //         pages: Array.isArray(value)
              //           ? value?.map((v: any) => v.value)
              //           : [value],
              //       });
              //     }}
              //     onDropdownVisibleChange={fetchCorrespondentData}
              //     filterOption={filterOption}
              //     options={correspondentOptions}
              //     allowClear
              //   />
              // </Form.Item>
          <Form.Item
            label={intl("correspondent")}
            name="correspondentsOut"
          >
            <Drawer
              url="/directories/outcoming-correspondents"
              name={edit ? correspondentIdOut?.map((value, index)=> (value.label))?.join(', ') : undefined}
              name2={contextTableData?.map((value, index)=> (value.Name))?.join(', ')}
              setFormFields={setFormFields}
              fieldName={"correspondentsOut"}
            >
              <Directories 
              url="/directories/outcoming-correspondents" 
              name="correspondentsOut"
              // selectedRowId={correspondentIdOut? contextTableData[0]?.id : undefined} 
              // selectedRowsId={ contextTableData?.length > 0 ? contextTableData?.map((value, index)=> (value.id)) : 
              //                  correspondentIdOut? correspondentIdOut.map((value, index)=> (value.value)):undefined} 
              selectedRowId={correspondentIdOut? contextTableData[0]?.id : undefined} 
              selectedRowsId={ contextTableData?.length > 0 ? contextTableData?.map((value, index)=> (value.id)) : 
                               correspondentsIds ? correspondentsIds : undefined} 
              allowMultiSelect={true} />
            </Drawer>
          </Form.Item>
              // <Form.Item label={intl("correspondent")} name="correspondent">
              //   <Select
              //     mode="multiple"
              //     onDropdownVisibleChange={fetchCorrespondentData}
              //     filterOption={filterOption}
              //     optionFilterProp="label"
              //     options={correspondentOptions}
              //     labelInValue
              //     allowClear
              //   />
              // </Form.Item>
            ))}
          {!(isOutcoming || isInternal) && (
            <Form.Item
              label={intl("addressed")}
              name="addressed"
              rules={[
                {
                  required: true,
                  message: intl("addressed-required"),
                },
              ]}
            >
              <Drawer
                url="/directories/employees"
                name={edit ? sessionData.Recipient : undefined}
                name2={rowData["/directories/employees"]?.data.fio}
                setFormFields={setFormFields}
                fieldName={"addressed"}
              >
                <Directories url="/directories/employees" selectedRowId={addressedId}/>
              </Drawer>
            </Form.Item>
          )}
          <Form.Item label={intl("content")} name="content">
            <TextArea rows={2} />
          </Form.Item>
          {!(isOutcoming || isInternal) ? (
            <Form.Item label={intl("control")} name="control">
              <DatePicker
                format={dateFormatList}
                placeholder={intl("choose-date-placeholder")}
                locale={language ? ua : en}
              />
            </Form.Item>
          ) : (
            <>
              <Form.Item label={intl("author")} name="author">
                <Drawer
                  url="/directories/employees"
                  name={edit ? sessionData.Author ?? sessionData.FIO : undefined}
                  name2={rowData["/directories/employees/author"]?.data.fio}
                  setFormFields={setFormFields}
                  fieldName={"author"}
                >
                  <Directories url="/directories/employees" name="author" selectedRowId={authorId ?? sessionData.clerksId}/>
                </Drawer>
              </Form.Item>
              <Form.Item label={intl("the-signatory")} name="signatory">
                <Drawer
                  url="/directories/employees"
                  name={edit ? sessionData.SignFIO : undefined}
                  name2={rowData["/directories/employees/signatory"]?.data.fio}
                  setFormFields={setFormFields}
                  fieldName={"signatory"}
                >
                  <Directories url="/directories/employees" name="signatory" selectedRowId={signatoryId}/>
                </Drawer>
              </Form.Item>
            </>
          )}
          {!isInternal && (
            <Form.Item
              label={intl("types-of-deliveries")}
              name="typeOfDelivery"
            >
              <Drawer
                url="/directories/types-of-deliveries"
                name={edit ? sessionData.typeSendName : undefined}
                name2={rowData["/directories/types-of-deliveries"]?.data.Name}
                setFormFields={setFormFields}
                fieldName={"typeOfDelivery"}
              >
                <Directories url="/directories/types-of-deliveries" selectedRowId={typeOfDeliveryId}/>
              </Drawer>
            </Form.Item>
          )}

          <Form.Item label={intl("notes")} name="notes">
            <Input />
          </Form.Item>
          <Space className={styles["space"]}>
            {!isInternal && (
              <Form.Item label={intl("num-delivery")} name="numDelivery">
                <Input />
              </Form.Item>
            )}
            <Form.Item label={intl("recorder")} name="recorder">
              <Input defaultValue={currentUser?.login} disabled={true} />
            </Form.Item>
          </Space>
        </DrawerProvider>
      ),
    },
    {
      key: "2",
      label: intl("storage"),
      children: (
        <DrawerProvider>
          <Space className={styles["space"]}>
            <Form.Item label={intl("number-of-pages")} name="numberOfPages">
              <Input />
            </Form.Item>
            <Form.Item
              label={intl("number-of-applications")}
              name="numberOfApplications"
            >
              <Input />
            </Form.Item>
          </Space>
          <Form.Item label={intl("case")} name="case">
            <Drawer
              url="/directories/nomenclature-of-cases"
              name={edit ? sessionData.Name_OfficialDoc : undefined}
              name2={
                rowData["/directories/nomenclature-of-cases"]?.data
                  .Name_OfficialDoc
              }
              setFormFields={setFormFields}
              fieldName={"case"}
            >
              <Directories url="/directories/nomenclature-of-cases" selectedRowId={caseId}/>
            </Drawer>
          </Form.Item>
          <Space className={styles["space"]}>
            <Form.Item label={intl("shelf-life")} name="shelfLife">
              <Input />
            </Form.Item>
            <Form.Item
              label={intl("written-off-in-the-case")}
              name="writtenOffInTheCase"
            >
              <DatePicker
                format={dateFormatList}
                placeholder={intl("choose-date-placeholder")}
                locale={language ? ua : en}
              />
            </Form.Item>
          </Space>
        </DrawerProvider>
      ),
    },
    // {
    //   key: "3",
    //   label: intl("additional-information"),
    //   // children: 'Content of Tab Pane 3',
    // },
  ];

  // items = items.filter(
  //   (item) => !(isOutcoming || isInternal) || item.key !== "3"
  // );
  // eta_const_typedoc_id
  const onFinish = async (values: any) => {
    console.log("Finish_form:", values);
    values.correspondentsOut = correspondentsIds;
    console.log("Finish_form:", correspondentsIds);
  try {
    if (activeModal === "edit") {
      values.id = sessionData.id;
    }

    let response;
    const endpoint =
      activeModal === "edit" ? "updatedatatable" : "adddatatable";

    let route = props.url || location.pathname;

    if (sessionData?.eta_const_typedoc_id === 1) {
      route = "/documents/incoming";
    } else if (sessionData?.eta_const_typedoc_id === 2) {
      route = "/documents/outcoming";
    } else if (sessionData?.eta_const_typedoc_id === 3) {
      route = "/documents/internal";
    }

    response = await request(`${route}/${endpoint}`, {
      method: "post",
      body: {
        documentId: sessionData?.bta_documents_id,
        page: props.url?.split("/").pop(),
        ...values,
      },
      cancelTokenKey: endpoint,
    });
    // console.log("RESPONSEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE ", response);
    activeModal !== "edit" && setDisabled({ ...disabled, edit: false });
    if (response.success && response.data && response.data[0]) {
      setSessionData(response.data[0]);
      setTableState({ 
        ...tableState,
        selectedRow: response.data[0].id
      });
      // props.onSubmitDone?.(response.success);
    }
    if (response.success) {
      props.onSubmitDone?.(response.success);
      form.resetFields();
      setRefresh(true);
    } else {
      props.onSubmitDone?.(response.success);
      
    }
  } catch (error) {
      props.onSubmitDone?.(false);
  }
  };

  const onFinishFailed = (errorInfo: any) => {
    props.onSubmitDone?.(false);
    // console.log("Failed documents add:", errorInfo);
  };

  return (
    <Form
      className={styles["form"]}
      name="documents"
      // {...layout}
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      // initialValues={{ head: false, rightControl: false, released: false }}
    >
      <Tabs defaultActiveKey="1" items={items} className={styles["tabs_style"]} />
    </Form>
  );
}
